import { Link } from 'react-router-dom'
import type { TechnologyDetail } from '../../data/technologies'

export function TechnologyNav({ technology }: { technology: TechnologyDetail }) {
  const links = technology.chapters.slice(0, 8)
  return <nav className="tech-local-nav" aria-label={`${technology.name} section navigation`}><div className="container"><Link to={technology.route}>{technology.name}</Link><div><a href="#overview">Overview</a>{links.map((link) => <a href={`#${link.id}`} key={link.id}>{link.title}</a>)}</div></div></nav>
}
